import axios from "axios"
import {HTTP_RESPONSE} from "../../Utility/Helpers/constants"
import UserProvider from "../../../security/UserProvier"

UserProvider.setToken()

const API_URL = process.env.REACT_APP_API_BASE_URL

const ChangelogRepository = {
  
  /**
   * Get changelog for specified language
   * @param {string} lang - Language code (en or fr)
   * @returns {Promise} Changelog data
   */
  getChangelog: async (lang = 'en') => {
    try {
      const response = await axios.get(`${API_URL}changelog/${lang}`)
      return response.data
    } catch (error) {
      console.error("Error fetching changelog:", error)
      throw new Error(HTTP_RESPONSE.INTERNAL_SERVER_ERROR)
    }
  },

  /**
   * Get only unreleased changes
   * @param {string} lang - Language code (en or fr)
   * @returns {Promise} Unreleased changelog data
   */
  getUnreleased: async (lang = 'en') => {
    try {
      const response = await axios.get(`${API_URL}changelog/${lang}/unreleased`)
      return response.data
    } catch (error) {
      console.error("Error fetching unreleased changelog:", error)
      throw new Error(HTTP_RESPONSE.INTERNAL_SERVER_ERROR)
    }
  },

  /**
   * Get specific version
   * @param {string} lang - Language code (en or fr)
   * @param {string} version - Version number (e.g., "2.2.0")
   * @returns {Promise} Version changelog data
   */
  getVersion: async (lang = 'en', version) => {
    try {
      const response = await axios.get(`${API_URL}changelog/${lang}/version/${version}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching version ${version}:`, error)
      throw new Error(HTTP_RESPONSE.INTERNAL_SERVER_ERROR)
    }
  }
}

export default ChangelogRepository
